<template>
  <div
    v-if="langs.length > 1"
    class="text-center"
  >
    <v-radio-group
      :value="activeLang"
    >
      <template v-slot:label>
        <h6 class="text-h6">{{ $t('common.language') }}</h6>
      </template>

      <v-radio
        v-for="lang in langs"
        :key="lang.code"
        :value="lang.code"
        @click="switchLocale(lang)"
      >
        <template v-slot:label>
          <img class="flag-icon" :src="`/images/admin/flags/${lang.code}.png`" :alt="lang.code"> &nbsp;&nbsp;{{ $t(`common.lang.${lang.code}`) }}
        </template>
      </v-radio>
    </v-radio-group>

    <v-divider />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import navigateMixin from '../../mixins/navigate'

export default {
  mixins: [navigateMixin],
  computed: {
    ...mapState('common', ['langs', 'activeLang']),
    selectedLang() {
      return _.find(this.langs, { code: this.activeLang })
    }
  },
}
</script>
